let isLogoutInProgress = false;

/**
 * 退出时会先在当前页面重置 store，再跳转到官网。
 * 该短生命周期标记用于阻止 store 重置触发的页面 effect 在跳转前发起请求或写回匿名 projectId。
 */
export function markLogoutInProgress() {
  isLogoutInProgress = true;
}

export function resetLogoutInProgress() {
  isLogoutInProgress = false;
}

export function getIsLogoutInProgress() {
  return isLogoutInProgress;
}
